import { CognitoIdentityProviderClient, RespondToAuthChallengeCommand, ChallengeNameType } from '@aws-sdk/client-cognito-identity-provider';
import { authConfig } from '../config/auth';

const cognitoClient = new CognitoIdentityProviderClient({
  region: authConfig.region,
});

export interface CompleteNewPasswordParams {
  session: string;
  username: string;
  newPassword: string;
}

/**
 * Complete the NEW_PASSWORD_REQUIRED challenge for invited users
 */
export async function completeNewPasswordChallenge(params: CompleteNewPasswordParams) {
  const command = new RespondToAuthChallengeCommand({
    ChallengeName: ChallengeNameType.NEW_PASSWORD_REQUIRED,
    ClientId: authConfig.userPoolClientId,
    ChallengeResponses: {
      USERNAME: params.username,
      NEW_PASSWORD: params.newPassword,
    },
    Session: params.session,
  });

  const response = await cognitoClient.send(command);
  return response.AuthenticationResult;
}

